module.exports = __webpack_public_path__ + "static/img/word.aa231823.png";